export class CreatePackageReqModel {
	public name : string;
	public channels : string[] = [];
	public customDevelopment : boolean;
	public maxAgent : string;
	public maxContact : string;
	public maxFlow : string;
	public maxSupervisor : string;
	public monthlyConversation : string;
	public monthlyNotification : string;
	public monthlyRental : number;
	public monthlyRentalRateCard : string;
	public ovrUsgConversation : string;
	public ovrUsgConversationCost : string;
	public ovrUsgConversationRateCard : boolean;
	public ovrUsgNotification : string;
	public ovrUsgNotificationCost : string;
	public ovrUsgNotificationRateCard : boolean;
	public reports : boolean;
	public roles : string;
	public sendMsgDashboard : boolean;
	public setupFee : string;
	public tps : number;
	public training : boolean;
	public waOfficialAcc : boolean;
	public customPackage: boolean;
	public countryCode: string;
	public costPerCustomer: string;
	public costPerBusiness: string;
	public setupFeeRateCard: boolean;
	public type: string;
	public recomended: string;

	public clone(source:any): CreatePackageReqModel {
		if (source.name) {
			this.name = source.name;
		}
		if (source.type) {
			this.type = source.type;
		}
		if (source.recomended) {
			this.recomended = source.recomended;
		}
		if (source.setupFeeRateCard) {
			this.setupFeeRateCard = source.setupFeeRateCard;
		}
		if (source.countryCode) {
			this.countryCode = source.countryCode;
		}
		if (source.costPerCustomer) {
			this.costPerCustomer = source.costPerCustomer;
		}
		if (source.costPerBusiness) {
			this.costPerBusiness = source.costPerBusiness;
		}
		if (source.customPackage) {
			this.customPackage = source.customPackage;
		}
		if (source.channels) {
			this.channels = [source.channels];
		}
		if (source.customDevelopment) {
			this.customDevelopment = source.customDevelopment;
		}
		if (source.maxAgent) {
			this.maxAgent = source.maxAgent;
		}
		if (source.maxContact) {
			this.maxContact = source.maxContact;
		}
		if (source.maxFlow) {
			this.maxFlow = source.maxFlow;
		}
		if (source.maxSupervisor) {
			this.maxSupervisor = source.maxSupervisor;
		}
		if (source.monthlyConversation) {
			this.monthlyConversation = source.monthlyConversation;
		}
		if (source.monthlyNotification) {
			this.monthlyNotification = source.monthlyNotification;
		}
		if (source.monthlyRental) {
			this.monthlyRental = source.monthlyRental;
		}
		if (source.monthlyRentalRateCard) {
			this.monthlyRentalRateCard = source.monthlyRentalRateCard;
		}
		if (source.ovrUsgConversation) {
			this.ovrUsgConversation = source.ovrUsgConversation;
		}
		if (source.ovrUsgConversationCost) {
			this.ovrUsgConversationCost = source.ovrUsgConversationCost;
		}
		if (source.ovrUsgConversationRateCard) {
			this.ovrUsgConversationRateCard = source.ovrUsgConversationRateCard;
		}
		if (source.ovrUsgNotification) {
			this.ovrUsgNotification = source.ovrUsgNotification;
		}
		if (source.ovrUsgNotificationCost) {
			this.ovrUsgNotificationCost = source.ovrUsgNotificationCost;
		}
		if (source.ovrUsgNotificationRateCard) {
			this.ovrUsgNotificationRateCard = source.ovrUsgNotificationRateCard;
		}
		if (source.reports) {
			this.reports = source.reports;
		}
		if (source.roles) {
			this.roles = source.roles;
		}
		if (source.sendMsgDashboard) {
			this.sendMsgDashboard = source.sendMsgDashboard;
		}
		if (source.setupFee) {
			this.setupFee = source.setupFee;
		}
		if (source.tps) {
			this.tps = source.tps;
		}
		if (source.training) {
			this.training = source.training;
		}
		if (source.waOfficialAcc) {
			this.waOfficialAcc = source.waOfficialAcc;
		}

		
		return this;
	}

	convert(): any {
		return {
			name: this.name,
			channels : this.channels ,
			customDevelopment : this.customDevelopment ,
			maxAgent : +this.maxAgent ,
			maxContact :+this.maxContact ,
			maxFlow : +this.maxFlow ,
			maxSupervisor : +this.maxSupervisor ,
			monthlyConversation : +this.monthlyConversation ,
			monthlyNotification : +this.monthlyNotification ,
			monthlyRental : +this.monthlyRental ,
			monthlyRentalRateCard : this.monthlyRentalRateCard ,
			ovrUsgConversation : this.ovrUsgConversation ,
			ovrUsgConversationCost : +this.ovrUsgConversationCost ,
			ovrUsgConversationRateCard : this.ovrUsgConversationRateCard ,
			ovrUsgNotification : this.ovrUsgNotification ,
			ovrUsgNotificationCost : +this.ovrUsgNotificationCost ,
			ovrUsgNotificationRateCard : this.ovrUsgNotificationRateCard ,
			reports : this.reports ,
			roles : this.roles ,
			sendMsgDashboard : this.sendMsgDashboard ,
			setupFee : +this.setupFee ,
			tps  : +this.tps  ,
			training  : this.training  ,
			waOfficialAcc  : this.waOfficialAcc,
			customPackage: this.customPackage,
			countryCode: this.countryCode,
			costPerBusiness: this.costPerBusiness,
			costPerCustomer: this.costPerCustomer,
			setupFeeRateCard: this.setupFeeRateCard,
			type: this.type,
			recomended: this.recomended
		};
	}
}